import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import firebase from "../../config/firebase";

import {
  FormGroup,
  Row,
  Col,
  CustomInput,
  Label,
  FormText,
  Alert,
  Input,
  ModalFooter,
  ModalBody,
  Modal,
  ModalHeader,
  Button,
} from "reactstrap";

import Navigations from "../../config/navbarAdmin";
import Sidebar from "../../config/Sidebar";
import "../../Sidebar.css";
// import "./VideosLinktyle.css";
// import "../../screens/Admin/styles.css";
var db = firebase.database();
class AddVideosLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headingName: "",
      category: "web-apps",
      status: false,
      body: "",
      githubLink: "",
      buttonLink: "",
      arr: [],
      image: null,
      url: "",
      progress: 0,
      currentPage: 0,
      pageSize: 5,
      editData: false,
      loaderToggle: false,
    };

    this.onHandleChange = this.onHandleChange.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    // this.customInputSwitched =this.customInputSwitched.bind(this);
  }

  customInputSwitched(buttonName, e) {
    this.setState({ status: e.target.checked });
  }
  handleChange(e) {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  }

  handleClick(e, index) {
    e.preventDefault();
    this.setState({
      currentPage: index,
    });
  }

  onDismiss() {
    this.setState({ visiableError: false });
  }

  onHandleChange(e) {
    this.setState({ body: e });
  }

  componentDidMount() {
    this.getData();
  }
  getData = () => {
    db.ref("VideoLink").on("value", (snapshot) => {
      var newArr = [];
      snapshot.forEach((data) => {
        var childData = data.val();
        console.log("childData", childData);
        newArr.push(childData);
      });
      this.setState({ arr: newArr.reverse() });
    });
  };

  handlesubmit(e) {
    e.preventDefault();
    const { VideoName, VideoId, editData } = this.state;
    var linkId = db.ref().child("VideosLink").push().key;

    if (editData === true) {
      firebase
        .database()
        .ref("VideoLink/" + this.state.linkId)
        .update({
          VideoName,
          VideoId,
          linkId: this.state.linkId,
          updateAt: new Date().toLocaleString(),
        })
        .then(() => {
          console.log("Document successfully written!");

          this.setState({
            openSnack: true,
            loaderToggle: false,
            modal: false,
          });
        })
        .catch((error) => {
          console.log("Error writing document: ", `${error}`);
        });
    } else if (editData === false) {
      firebase
        .database()
        .ref("VideoLink/" + linkId)
        .set({
          VideoName,
          VideoId,
          createAt: new Date().toLocaleString(),
          linkId,
        })
        .then(() => {
          console.log("Document successfully written!");

          this.setState({
            openSnack: true,
            loaderToggle: false,
            modal: false,
          });
        })
        .catch((error) => {
          console.log("Error writing document: ", `${error}`);
        });
    }
  }

  deleteItem = (id, image) => {
    db.ref("VideoLink/" + id)
      .remove()
      .then((e) => {
        toast.success("Deleted Successfully !", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        console.log("error", error);
        alert("Error: ", error);
        this.setState({
          errorMessage: error.message,
          visiableError: true,
        });
      });
  };

  render() {
    const {
      arr,
      category,
      image,
      errorMessage,
      errorImage,
      success,
      textSearch,
      searchData,
      currentPage,
      pageSize,
    } = this.state;
    console.log("arr", arr);
    var errmsg = errorMessage || errorImage;
    var imgCheck = image && image.name;
    const string = Math.ceil(arr.length / pageSize);
    var res = [...Array(string)];
    const sear = textSearch ? searchData : arr;
    return (
      <div class="sb-nav-fixed " id="zoomed">
        <Navigations />
        <div id="layoutSidenav">
          <Sidebar />
          <div id="layoutSidenav_content">
            <main>
              <div class="container-fluid">
                <Modal
                  isOpen={this.state.modal}
                  backdrop="static"
                  size="md"
                  scrollable={true}
                >
                  <ModalHeader
                    close={
                      <button
                        className="close"
                        onClick={() =>
                          this.setState({
                            modal: !this.state.modal,
                          })
                        }
                      >
                        &times;
                      </button>
                    }
                  >
                    {this.state.editData === true ? "Edit" : "Add"} Videos Link
                  </ModalHeader>

                  <ModalBody>
                    <form id="myForm" onSubmit={this.handlesubmit}>
                      <div class="mb-3">
                        <label for="exampleInputEmail1" class="form-label">
                          Video Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Video Name"
                          required
                          name="VideoName"
                          value={this.state.VideoName}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">
                          Video Id
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputPassword1"
                          placeholder="Video Id"
                          required
                          name="VideoId"
                          value={this.state.VideoId}
                          onChange={this.handleChange}
                        />
                      </div>

                      <button
                        class="btn btn-primary"
                        type="submit"
                        disabled={
                          this.state.loaderToggle === false ? false : true
                        }
                      >
                        {this.state.loaderToggle === true ? (
                          <>
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            >
                              {" "}
                            </span>
                            Loading...
                          </>
                        ) : (
                          <>
                            {" "}
                            {this.state.editData === true ? "Edit" : "Add"} Item
                          </>
                        )}
                      </button>
                    </form>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      onClick={() =>
                        this.setState({
                          modal: !this.state.modal,
                        })
                      }
                    >
                      Close
                    </button>
                  </ModalFooter>
                </Modal>

                <div class="d-flex align-items-center">
                  <h1
                    style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
                    class="mt-3"
                  >
                    <i class="fas fa-tasks"></i> Videos Link
                  </h1>
                  <button
                    type="button"
                    class="btn btn-outline-primary ml-auto"
                    // data-toggle="modal"
                    // data-target="#staticBackdrop "
                    onClick={() =>
                      this.setState({
                        modal: true,
                        VideoName: "",
                        VideoId: "",
                        editData: false,
                      })
                    }
                  >
                    Add Link
                  </button>
                </div>

                {/* <div className="view-content">{this.renderPosts()}</div> */}
                <div>
                  <div class="row">
                    {arr.map((e, i) => {
                      return (
                        <div class="col-sm-12 col-md-4 mt-4 mb-4">
                          <div class="card-Video">
                            {/* <img src="..." class="card-img-top" alt="..." /> */}
                            <iframe
                              class="card-img-top embed-responsive-item"
                              src={`https://www.youtube.com/embed/${e.VideoId}`}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              title="Embedded youtube"
                            />
                            <div
                              style={{
                                flex: "1 1 auto",
                                minHeight: "1px",
                                margin: "8px",
                              }}
                            >
                              <h5 class="card-text">{e.VideoName}</h5>
                              <p class="card-text">Create: {e.createAt}</p>
                              {e.updateAt && (
                                <p class="card-text">Update: {e.updateAt}</p>
                              )}
                            </div>
                            <div class="card-footer text-muted">
                              <button
                                type="button"
                                class="btn btn-success btn-sm mr-1"
                                onClick={() =>
                                  this.setState({
                                    VideoName: e.VideoName,
                                    VideoId: e.VideoId,
                                    linkId: e.linkId,
                                    modal: true,
                                    editData: true,
                                  })
                                }
                              >
                                Edit
                              </button>
                              <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure want to Delete this Item?"
                                    )
                                  ) {
                                    this.deleteItem(e.linkId);
                                  }
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    dwOpen: state.dw,
  };
};

export default withRouter(connect(mapStateToProps, null)(AddVideosLink));
